import firebase from "firebase/app";
import "firebase/firestore";

export default function singleQuery(query) {
    let postRef = firebase.firestore().collection(query.database).doc(query.doc)
    return postRef.get()
}